export default {
    areANIFieldsRequired: hasAddlNamedInsured => hasAddlNamedInsured,
    isMultiProductPolicyNumberValid: multiProductPolicyNumberValid => multiProductPolicyNumberValid,
};
